export function startClient({ app, router, store }) {
    if (window.__INITIAL_STATE__) {
        store.replaceState(window.__INITIAL_STATE__);
    }

    router.onReady(() => {
        app.$mount("#app");
    });
}
